// Pure helpers for re-confirming detected faces. Client-safe.

const sameBox = (a: unknown, b: unknown) => JSON.stringify(a ?? null) === JSON.stringify(b ?? null);

/**
 * True when confirming `faces` must rebuild the characters (blank traits, analysis re-run).
 * False when they are the same people as before (same count, same boxes), so the traits
 * already analysed or entered are kept. Going Back to the photo step and Next must not wipe them.
 */
export function shouldResetCharacters(
  existing: Array<{ bbox?: unknown }> | null | undefined,
  faces: Array<{ bbox?: unknown }>,
): boolean {
  if (!existing || existing.length === 0) return true;
  if (existing.length !== faces.length) return true;
  return faces.some((f, i) => !sameBox(existing[i]?.bbox, f.bbox));
}

/** Keep each character's traits but take name and thumbnail from the freshly confirmed face (a rename on Back). */
export function mergeFaceIdentity<C extends { name?: string; thumbnail?: string }>(
  existing: C[],
  faces: Array<{ name?: string; thumbnail?: string }>,
): C[] {
  return existing.map((c, i) => ({
    ...c,
    name: faces[i]?.name ?? c.name ?? '',
    thumbnail: faces[i]?.thumbnail || c.thumbnail || '',
  }));
}
